<template>
	<div :class="['page', {
		loading: loading
	}]">
		<div v-if="page">
			<header class="title-with-close">
				<button class="close" @click.stop.prevent="closePage">
					<i class="icon-close"></i> Avbryt
				</button>
				<h1>{{ page.title }}</h1>
			</header>
			<div v-if="page" v-html="sanitizedHtml"></div>
			<a v-if="page.link && page.link_text" :href="page.link" target="_blank">{{ page.link_text }}</a>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		pageSlug: {
			type: String,
			required: true,
		},
		endpoint: {
			type: String,
			required: true,
		}
	},
	data() {
		return {
			page: null,
			loading: false,
		}
	},
	computed: {
		sanitizedHtml() {
			return this.$sanitize(this.page.text);
		}
	},
	methods: {
		loadPage() {
			if (this.pageSlug==='') return;
			this.loading = true;
			const endpointUrl = this.endpoint + this.pageSlug;
			fetch(endpointUrl)
			.then(response => response.json())
			.then(data => {
				this.loading = false;
				this.page = data.data.page;
			});
		},
		closePage() {
			this.$emit('closePage')
		}
	},
	mounted() {
		this.loadPage();
	}
};
</script>
